<!-- 详情弹窗 -->
<template>
  <a-modal
    title="详情"
    :width="640"
    :footer="null"
    :visible="visible"
    @update:visible="updateVisible"
  >
    <a-form
      class="ud-form-detail"
      :label-col="{ sm: { span: 8 }, xs: { span: 6 } }"
      :wrapper-col="{ sm: { span: 16 }, xs: { span: 18 } }"
    >
      <a-row :gutter="16">
        <a-col :sm="12" :xs="24">
          <!-- 品牌名称 -->
          <a-form-item label="品牌名称:">
            <div class="ud-text-secondary">
              {{ data.brandName }}
            </div>
          </a-form-item>
          <!-- 型号 -->
          <a-form-item label="型号:">
            <div class="ud-text-secondary">
              {{ data.model }}
            </div>
          </a-form-item>
          <!-- 运营商名称 -->
          <a-form-item label="运营商名称:">
            <div class="ud-text-secondary">
              {{ data.operatorName }}
            </div>
          </a-form-item>
          <!-- 额定电量 -->
          <a-form-item label="额定电量:">
            <div class="ud-text-secondary">
              {{ data.ratedCapacity }}
            </div>
          </a-form-item>
        </a-col>
        <a-col :sm="12" :xs="24">
          <!-- 额定电压 -->
          <a-form-item label="额定电压:">
            <div class="ud-text-secondary">
              {{ data.ratedVoltage }}
            </div>
          </a-form-item>
          <!-- 电池尺寸 -->
          <a-form-item label="电池尺寸:">
            <div class="ud-text-secondary">
              {{ data.szie }}
            </div>
          </a-form-item>
          <!-- 重量 -->
          <a-form-item label="重量:">
            <div class="ud-text-secondary">
              {{ data.weight }}
            </div>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'brandDetail',
  emits: ['update:visible'],
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 数据
    data: Object
  },
  methods: {
    /* 更新visible */
    updateVisible(value) {
      this.$emit('update:visible', value)
    }
  }
}
</script>

<style scoped>
</style>
